import Generate from './DocumentTemplateGenerate'

export default {
  Generate,
}
